import { Select, Modal, Tooltip, message } from 'antd';
import React, { useState } from 'react';
import { DoubtCircle } from 'patternx-svg';
import styles from './index.module.less';
import { isEqual } from 'lodash-es';

interface Props {
  onClose: (isEmpty: boolean, row: any) => void;
  onChange: (params: any, row: any) => void;
  adsorptionCategorys: any[];
  referencePointHorizontals: any[];
  referencePointVerticals: any[];
  referenceFaceVerticals: any[];
  referenceFaceHorizontals: any[];
  targetHosts: any[];
  data: any;
}
const AdsorptionModal: React.FC<Props> = (props: Props) => {
  const {
    onClose,
    onChange,
    adsorptionCategorys,
    referencePointHorizontals,
    referencePointVerticals,
    referenceFaceVerticals,
    referenceFaceHorizontals,
    targetHosts,
    data,
  } = props;

  const [adsorptionCategory, setAdsorptionCategory] = useState<string>(
    data?.adsorptionCategory || 'custom',
  );
  const [adsorptionCategoryStatus, setAdsorptionCategoryStatus] = useState('');
  const [referencePointHorizontal, setReferencePointHorizontal] = useState<string>(
    data?.extData?.referencePointHorizontal || undefined,
  );
  const [referencePointHorizontalStatus, setReferencePointHorizontalStatus] = useState('');
  const [referencePointVertical, setReferencePointVertical] = useState<string>(
    data?.extData?.referencePointVertical || undefined,
  );
  const [referencePointVerticalStatus, setReferencePointVerticalStatus] = useState('');
  const [referenceFaceVertical, setReferenceFaceVertical] = useState<string>(
    data?.extData?.referenceFaceVertical || undefined,
  );
  const [referenceFaceVerticalStatus, setReferenceFaceVerticalStatus] = useState('');
  const [referenceFaceHorizontal, setReferenceFaceHorizontal] = useState<string>(
    data?.extData?.referenceFaceHorizontal || undefined,
  );
  const [referenceFaceHorizontalStatus, setReferenceFaceHorizontalStatus] = useState('');
  const [targetHost, setTargetHost] = useState<string[]>(data?.extData?.targetHost || undefined);
  const [targetHostStatus, setTargetHostStatus] = useState('');

  const isEmpty = (isMessage?: boolean) => {
    let isTip = false;
    if (!adsorptionCategory) {
      isTip = true;
      setAdsorptionCategoryStatus('error');
    }
    if (!referencePointHorizontal) {
      isTip = true;
      setReferencePointHorizontalStatus('error');
    }
    if (!referencePointVertical) {
      isTip = true;
      setReferencePointVerticalStatus('error');
    }
    if (!referenceFaceHorizontal) {
      isTip = true;
      setReferenceFaceHorizontalStatus('error');
    }
    if (!referenceFaceVertical) {
      isTip = true;
      setReferenceFaceVerticalStatus('error');
    }
    if (targetHost?.length === 0 || !targetHost) {
      isTip = true;
      setTargetHostStatus('error');
    }
    if (isTip && isMessage) {
      message.warning('有内容未填写');
    }
    return isTip;
  };

  const onSubmit = () => {
    const isInvalidate = isEmpty(true);
    if (isInvalidate) {
      return;
    }
    onChange(
      {
        adsorptionCategory,
        extData: {
          referencePointHorizontal,
          referencePointVertical,
          referenceFaceVertical,
          referenceFaceHorizontal,
          targetHost,
        },
      },
      data,
    );
  };

  const onCancle = () => {
    const isInvalidate = data?.adsorptionCategory === 'custom' && isEmpty(false);
    onClose(isInvalidate, data);
  };

  const onChange1 = (val: string, option: any) => {
    const extend = JSON.parse(option?.extend || '{}');
    setAdsorptionCategory(val);
    if (val !== 'custom') {
      setReferencePointHorizontal(extend?.referencePointHorizontal || undefined);
      setReferencePointVertical(extend?.referencePointVertical || undefined);
      setReferenceFaceVertical(extend?.referenceFaceVertical || undefined);
      setReferenceFaceHorizontal(extend?.referenceFaceHorizontal || undefined);
      setTargetHost(extend?.targetHost || undefined);
    }
  };

  const onChange2 = (val: string) => {
    setReferencePointHorizontal(val);
    if (adsorptionCategory !== 'custom') {
      const defaultVal = adsorptionCategorys?.find((a) => a.value === adsorptionCategory)?.extData
        ?.referencePointHorizontal;
      if (val !== defaultVal) {
        setAdsorptionCategory('custom');
      }
    }
  };

  const onChange3 = (val: string) => {
    setReferencePointVertical(val);
    if (adsorptionCategory !== 'custom') {
      const defaultVal = adsorptionCategorys?.find((a) => a.value === adsorptionCategory)?.extData
        ?.referencePointVertical;
      if (val !== defaultVal) {
        setAdsorptionCategory('custom');
      }
    }
  };

  const onChange4 = (val: string) => {
    setReferenceFaceVertical(val);
    if (adsorptionCategory !== 'custom') {
      const defaultVal = adsorptionCategorys?.find((a) => a.value === adsorptionCategory)?.extData
        ?.referenceFaceVertical;
      if (val !== defaultVal) {
        setAdsorptionCategory('custom');
      }
    }
  };

  const onChange5 = (val: string) => {
    setReferenceFaceHorizontal(val);
    if (adsorptionCategory !== 'custom') {
      const defaultVal = adsorptionCategorys?.find((a) => a.value === adsorptionCategory)?.extData
        ?.referenceFaceHorizontal;
      if (val !== defaultVal) {
        setAdsorptionCategory('custom');
      }
    }
  };

  const onChange6 = (val: string[]) => {
    setTargetHost(val);
    if (adsorptionCategory !== 'custom') {
      const defaultVal = adsorptionCategorys?.find((a) => a.value === adsorptionCategory)?.extData
        ?.targetHost;
      if (!isEqual(val, defaultVal)) {
        setAdsorptionCategory('custom');
      }
    }
  };

  return (
    <Modal
      open={true}
      width={600}
      title="行为规则"
      onOk={onSubmit}
      onCancel={onCancle}
      okButtonProps={{ disabled: false }}
      centered
    >
      <div className="flex-ai-center">
        <span className={styles.label}>行为规则</span>
        <Select
          placeholder="请选择行为规则"
          value={adsorptionCategory}
          onChange={(val: any, option: any) => onChange1(val, option)}
          style={{ width: '100%' }}
          options={adsorptionCategorys}
          showArrow
          // allowClear
          status={adsorptionCategoryStatus === 'error' ? 'error' : ''}
          onFocus={() => setAdsorptionCategoryStatus('')}
          popupClassName={styles.adsorptionSelect}
        />
      </div>
      <div className="flex-ai-center mt12">
        <span className={styles.label}>
          平面对齐
          <Tooltip title="平面对齐">
            <DoubtCircle size={16} className={styles.icon} />
          </Tooltip>
        </span>
        <Select
          placeholder="请选择平面对齐"
          value={referencePointHorizontal}
          onChange={onChange2}
          style={{ width: '100%' }}
          options={referencePointHorizontals}
          showArrow
          // allowClear
          status={referencePointHorizontalStatus === 'error' ? 'error' : ''}
          onFocus={() => setReferencePointHorizontalStatus('')}
        />
      </div>
      <div className="flex-ai-center mt12">
        <span className={styles.label}>
          标高对齐
          <Tooltip title="标高对齐">
            <DoubtCircle size={16} className={styles.icon} />
          </Tooltip>
        </span>
        <Select
          placeholder="请选择标高对齐"
          value={referencePointVertical}
          onChange={onChange3}
          style={{ width: '100%' }}
          options={referencePointVerticals}
          showArrow
          // allowClear
          status={referencePointVerticalStatus === 'error' ? 'error' : ''}
          onFocus={() => setReferencePointVerticalStatus('')}
        />
      </div>
      <div className="flex-ai-center mt12">
        <span className={styles.label}>
          上下吸附
          <Tooltip title="上下吸附">
            <DoubtCircle size={16} className={styles.icon} />
          </Tooltip>
        </span>
        <Select
          placeholder="请选择上下吸附"
          value={referenceFaceVertical}
          onChange={onChange4}
          style={{ width: '100%' }}
          options={referenceFaceVerticals}
          showArrow
          // allowClear
          status={referenceFaceVerticalStatus === 'error' ? 'error' : ''}
          onFocus={() => setReferenceFaceVerticalStatus('')}
        />
      </div>
      <div className="flex-ai-center mt12">
        <span className={styles.label}>
          水平吸附
          <Tooltip title="水平吸附">
            <DoubtCircle size={16} className={styles.icon} />
          </Tooltip>
        </span>
        <Select
          placeholder="请选择水平吸附"
          value={referenceFaceHorizontal}
          onChange={onChange5}
          style={{ width: '100%' }}
          options={referenceFaceHorizontals}
          showArrow
          // allowClear
          status={referenceFaceHorizontalStatus === 'error' ? 'error' : ''}
          onFocus={() => setReferenceFaceHorizontalStatus('')}
        />
      </div>
      <div className="flex-ai-center mt12">
        <span className={styles.label}>
          吸附主体
          <Tooltip title="吸附主体">
            <DoubtCircle size={16} className={styles.icon} />
          </Tooltip>
        </span>
        <Select
          mode="multiple"
          placeholder="请选择吸附主体"
          value={targetHost}
          onChange={onChange6}
          style={{ width: '100%' }}
          options={targetHosts}
          showArrow
          // allowClear
          status={targetHostStatus === 'error' ? 'error' : ''}
          onFocus={() => setTargetHostStatus('')}
        />
      </div>
    </Modal>
  );
};

export default React.memo(AdsorptionModal);
